import React, {Component} from 'react';
import {compose} from 'recompose';
import {withFirebase} from '../Firebase';
import {Grid, Box, Button} from '@theme-ui/components'
import {AuthUserContext, withAuthorization} from '../Session';
import Modal from "react-bootstrap/Modal";
import Message from "../Modal/Message/Message";
import * as ROUTES from "../../constants/routes";

const RegisterMultiFactorPage = () => (
    <div>
        <AuthUserContext.Consumer>
            {authUser => {
                if (authUser.multiFactor.enrolledFactors.length > 0) {
                    return (<h3>You are enrolled for multi factor auth</h3>);
                } else if(authUser.emailVerified) {
                    return (<RegisterNonAuth/>)
                } else {
                    return (<VerifyEmail/>)
                }
            }
            }
        </AuthUserContext.Consumer>
    </div>
);

const INITIAL_STATE = {
    phone: '',
    showPinModal: false,
    pin: '',
    error: null,
};

class VerifyEmailBase extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            modalMessage: '',
        };
    }

    closeModal() {
        this.setState({showModal: false});
    };

    verifyEmail = () => {
        this.props.firebase.verifyEmail().then(() => {
            this.setState({
                showModal: true,
                modalMessage: "Success!!! Check your inbox.",
            });
        });
    }

    render() {
        const {showModal, modalMessage} = this.state;
        return (
            <Box>
                <Modal show={showModal} onHide={this.closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Verify Email</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {modalMessage}
                    </Modal.Body>
                </Modal>
                <Button variant="warning" onClick={this.verifyEmail}>Verify Email</Button>
            </Box>
    )
    }
}

class RegisterFormBase extends Component {

    constructor(props) {
        super(props);
        this.state = {...INITIAL_STATE};
        this.verifier = null;
    }

    componentDidMount() {
        this.verifier = this.props.firebase.recaptchaVerifier("sign-in-button");
    }

    onSubmit = event => {
        const {phone} = this.state;
        this.props.firebase
            .doRegisterForMultiFactorAuth(phone, this.verifier)
            .then((verificationId) => {
                this.setState({
                    verificationId: verificationId,
                    showPinModal: true
                });
            })
            .catch(error => {
                this.setState({...INITIAL_STATE});
            });
        event.preventDefault();
    };

    onChange = event => {
        this.setState({[event.target.name]: event.target.value});
    };

    handleClose = () => {
        this.setState({showPinModal: false});
    }

    handlePinEnter = () => {
        this.setState({showPinModal: false});
        const {pin, verificationId} = this.state;
        this.props.firebase.doEnrollUserForMultiFactor(verificationId, pin).then( () => {
            this.setState({
                pin: '',
                verificationId: null
            })
            window.location.reload();
        })
    }

    render() {
        const {phone, showPinModal, pin, error} = this.state;
        const isInvalid = phone === '';
        return (
            <Box
                sx={{width: ['90%', '50%', '25%']}}>
                <Modal show={showPinModal} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Enter the PIN. Check your phone.</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form>
                            <Grid columns={[1, null, 1]}>
                                <input
                                    name="pin"
                                    value={pin}
                                    onChange={this.onChange}
                                    type="password"
                                    placeholder="PIN"
                                />
                            </Grid>
                        </form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={this.handlePinEnter}>
                            Ok
                        </Button>
                    </Modal.Footer>
                </Modal>
                <form onSubmit={this.onSubmit}>
                    <Grid
                        columns={[1, null, 1]}>
                        <input
                            name="phone"
                            value={phone}
                            onChange={this.onChange}
                            type="text"
                            placeholder="Phone"
                        />
                        <Button disabled={isInvalid} type="submit" id="sign-in-button">
                            Register Phone Multi Factor
                        </Button>
                        {error && <p>{error.message}</p>}
                    </Grid>
                </form>
            </Box>
        );
    }
}

const RegisterNonAuth = () => (
    <Box
        sx={{margin: 20}}>
        <h3>Register Phone For Multi Factor Auth (With SMS code verification).</h3>
        <RegisterForm/>
    </Box>
);

const VerifyEmail = () => (
    <Box
        sx={{margin: 20}}>
        <h3>You have to verify your email, before you signup for multi factor auth (With SMS code verification).</h3>
        <VerifyButton/>
    </Box>
);
const VerifyButton = compose(
    withFirebase,
)(VerifyEmailBase);

const RegisterForm = compose(
    withFirebase,
)(RegisterFormBase);
const condition = authUser => !!authUser;
export default withAuthorization(condition)(RegisterMultiFactorPage);
export {RegisterForm, VerifyButton};